var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_15380)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8551 14.7294V14.5483C10.8587 13.9268 10.9137 13.4315 11.0202 13.0621C11.1303 12.6928 11.2901 12.3945 11.4996 12.1673C11.7092 11.94 11.9613 11.734 12.256 11.5494C12.4762 11.4073 12.6733 11.2599 12.8473 11.1072C13.0213 10.9545 13.1598 10.7859 13.2628 10.6012C13.3658 10.413 13.4173 10.2035 13.4173 9.97266C13.4173 9.72763 13.3587 9.51278 13.2415 9.32812C13.1243 9.14347 12.9663 9.00142 12.7674 8.90199C12.5721 8.80256 12.3555 8.75284 12.1175 8.75284C11.8867 8.75284 11.6683 8.80433 11.4624 8.90732C11.2564 9.00675 11.0877 9.15589 10.9563 9.35476C10.8249 9.55007 10.7539 9.79332 10.7433 10.0845H8.56996C8.58771 9.37429 8.75817 8.78835 9.08132 8.3267C9.40447 7.86151 9.83239 7.51527 10.3651 7.288C10.8977 7.05717 11.4854 6.94176 12.1282 6.94176C12.8349 6.94176 13.4599 7.05895 14.0032 7.29332C14.5465 7.52415 14.9727 7.85973 15.2816 8.30007C15.5906 8.74041 15.745 9.27131 15.745 9.89276C15.745 10.3082 15.6758 10.6776 15.5373 11.0007C15.4023 11.3203 15.2124 11.6044 14.9673 11.853C14.7223 12.098 14.4329 12.32 14.0991 12.5188C13.8185 12.6857 13.5877 12.8597 13.4066 13.0408C13.229 13.2219 13.0959 13.4315 13.0071 13.6694C12.9219 13.9073 12.8775 14.2003 12.8739 14.5483V14.7294H10.8551ZM11.9098 18.1385C11.5547 18.1385 11.2511 18.0142 10.9989 17.7656C10.7504 17.5135 10.6278 17.2116 10.6314 16.8601C10.6278 16.5121 10.7504 16.2138 10.9989 15.9652C11.2511 15.7166 11.5547 15.5923 11.9098 15.5923C12.2472 15.5923 12.5437 15.7166 12.7994 15.9652C13.055 16.2138 13.1847 16.5121 13.1882 16.8601C13.1847 17.0945 13.1225 17.3093 13.0018 17.5046C12.8846 17.6964 12.7301 17.8509 12.5384 17.968C12.3466 18.0817 12.1371 18.1385 11.9098 18.1385Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_15380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDark);
export default __webpack_public_path__ + "static/media/QuestionDark.5ae87432.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_15380)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8551 14.7294V14.5483C10.8587 13.9268 10.9137 13.4315 11.0202 13.0621C11.1303 12.6928 11.2901 12.3945 11.4996 12.1673C11.7092 11.94 11.9613 11.734 12.256 11.5494C12.4762 11.4073 12.6733 11.2599 12.8473 11.1072C13.0213 10.9545 13.1598 10.7859 13.2628 10.6012C13.3658 10.413 13.4173 10.2035 13.4173 9.97266C13.4173 9.72763 13.3587 9.51278 13.2415 9.32812C13.1243 9.14347 12.9663 9.00142 12.7674 8.90199C12.5721 8.80256 12.3555 8.75284 12.1175 8.75284C11.8867 8.75284 11.6683 8.80433 11.4624 8.90732C11.2564 9.00675 11.0877 9.15589 10.9563 9.35476C10.8249 9.55007 10.7539 9.79332 10.7433 10.0845H8.56996C8.58771 9.37429 8.75817 8.78835 9.08132 8.3267C9.40447 7.86151 9.83239 7.51527 10.3651 7.288C10.8977 7.05717 11.4854 6.94176 12.1282 6.94176C12.8349 6.94176 13.4599 7.05895 14.0032 7.29332C14.5465 7.52415 14.9727 7.85973 15.2816 8.30007C15.5906 8.74041 15.745 9.27131 15.745 9.89276C15.745 10.3082 15.6758 10.6776 15.5373 11.0007C15.4023 11.3203 15.2124 11.6044 14.9673 11.853C14.7223 12.098 14.4329 12.32 14.0991 12.5188C13.8185 12.6857 13.5877 12.8597 13.4066 13.0408C13.229 13.2219 13.0959 13.4315 13.0071 13.6694C12.9219 13.9073 12.8775 14.2003 12.8739 14.5483V14.7294H10.8551ZM11.9098 18.1385C11.5547 18.1385 11.2511 18.0142 10.9989 17.7656C10.7504 17.5135 10.6278 17.2116 10.6314 16.8601C10.6278 16.5121 10.7504 16.2138 10.9989 15.9652C11.2511 15.7166 11.5547 15.5923 11.9098 15.5923C12.2472 15.5923 12.5437 15.7166 12.7994 15.9652C13.055 16.2138 13.1847 16.5121 13.1882 16.8601C13.1847 17.0945 13.1225 17.3093 13.0018 17.5046C12.8846 17.6964 12.7301 17.8509 12.5384 17.968C12.3466 18.0817 12.1371 18.1385 11.9098 18.1385Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_15380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDark);
export default __webpack_public_path__ + "static/media/QuestionDark.5ae87432.svg";
export { ForwardRef as ReactComponent };